<div class="tickets-suporte" [class.compacto]="compacto" *ngIf="empresaId">
  <div class="tickets-topo">
    <div>
      <p class="secao-label">Tickets</p>
      <h5>{{contato?.id ? 'Tickets do contato' : 'Tickets abertos'}}</h5>
    </div>

    <div class="tickets-topo-acoes">
      <button type="button"
              class="btn btn-sm"
              [ngClass]="estaEmImplantacao() ? 'btn-warning' : 'btn-outline-warning'"
              (click)="estaEmImplantacao() ? encerreImplantacao() : inicieImplantacao()"
              [disabled]="salvandoAtividadeImplantacao || carregandoAtividadeImplantacao"
              *ngIf="podeUsarBotaoImplantacao()">
        <i class="fa mr-1" [ngClass]="salvandoAtividadeImplantacao ? 'fa-spinner fa-spin' : 'fa-user-clock'"></i>
        {{estaEmImplantacao() ? 'Encerrar implantacao' : 'Estou em implantacao'}}
      </button>

      <button type="button"
              class="btn btn-sm btn-primary"
              (click)="abraNovoTicket()"
              *ngIf="!novoTicketAberto && podeCriarTicket()">
        <i class="fa fa-plus mr-1"></i>
        Novo
      </button>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="erro">
    {{erro}}
  </div>

  <div class="alert alert-danger" *ngIf="erroAtividadeImplantacao">
    {{erroAtividadeImplantacao}}
  </div>

  <div class="implantacao-status" *ngIf="estaEmImplantacao()">
    <i class="fa fa-user-clock mr-1"></i>
    Fora do rodizio ate {{atividadeImplantacaoAtual.dataFim | date:'HH:mm'}} por reuniao de implantacao.
  </div>

  <div class="alert alert-warning" *ngIf="avisoAvaliacao">
    {{avisoAvaliacao}}
  </div>

  <form class="novo-ticket" *ngIf="novoTicketAberto" (ngSubmit)="crieTicket()">
    <div class="form-group">
      <label>Título</label>
      <input type="text"
             class="form-control"
             name="tituloTicketSuporte"
             [(ngModel)]="novoTicket.titulo"
             maxlength="180"
             autocomplete="off">
    </div>

    <div class="form-group">
      <label>Contexto inicial</label>
      <textarea class="form-control"
                rows="3"
                name="descricaoTicketSuporte"
                [(ngModel)]="novoTicket.descricao"></textarea>
    </div>

    <div class="linha-form">
      <div class="form-group">
        <label>Tipo</label>
        <select class="form-control"
                name="tipoTicketSuporte"
                [(ngModel)]="novoTicket.tipo">
          <option *ngFor="let tipo of tiposTicket" [ngValue]="tipo.valor">
            {{tipo.texto}}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Área do sistema</label>
        <select class="form-control"
                name="areaTicketSuporte"
                [(ngModel)]="novoTicket.areaSistema">
          <option *ngFor="let area of areasSistema" [ngValue]="area.valor">
            {{area.texto}}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group" *ngIf="novoTicket.tipo === 'OUTRO'">
      <label>Descrição do tipo</label>
      <input type="text"
             class="form-control"
             name="tipoOutroTicketSuporte"
             [(ngModel)]="novoTicket.tipoOutroDescricao"
             maxlength="120"
             autocomplete="off">
    </div>

    <div class="linha-form">
      <div class="form-group">
        <label>Prioridade</label>
        <select class="form-control"
                name="prioridadeTicketSuporte"
                [(ngModel)]="novoTicket.prioridade">
          <option *ngFor="let prioridade of prioridades" [ngValue]="prioridade.valor">
            {{prioridade.texto}}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Responsável</label>
        <select class="form-control"
                name="responsavelTicketSuporte"
                [(ngModel)]="novoTicket.responsavelUsuarioId">
          <option [ngValue]="null">Criador do ticket</option>
          <option *ngFor="let responsavel of responsaveis" [ngValue]="responsavel.id">
            {{responsavel.nome}}
          </option>
        </select>
      </div>
    </div>

    <div class="acoes-form">
      <button type="button" class="btn btn-link btn-sm" (click)="canceleNovoTicket()">Cancelar</button>
      <button type="submit" class="btn btn-primary btn-sm" [disabled]="criando">
        <i class="fa" [ngClass]="criando ? 'fa-spinner fa-spin' : 'fa-check'"></i>
        Criar ticket
      </button>
    </div>
  </form>

  <div class="estado-vazio" *ngIf="carregando">
    Carregando tickets...
  </div>

  <div class="estado-vazio" *ngIf="!carregando && !existemTickets">
    {{contato?.id ? 'Nenhum ticket aberto para este contato.' : 'Nenhum ticket aberto para esta empresa.'}}
  </div>

  <div class="tickets-lista" *ngIf="existemTickets">
    <button type="button"
            class="ticket-item"
            *ngFor="let ticket of tickets"
            [class.selecionado]="ticketSelecionado?.id === ticket.id"
            [ngClass]="[classePrioridade(ticket.prioridade), classeIdade(ticket)]"
            (click)="selecioneTicket(ticket)">
      <span class="ticket-titulo">
        <small class="ticket-numero">#{{ticket.id}}</small>
        {{ticket.titulo}}
      </span>
      <span class="ticket-meta">
        {{textoStatus(ticket.status)}}
        <span class="badge badge-prioridade" [ngClass]="classePrioridade(ticket.prioridade)">
          {{textoPrioridade(ticket.prioridade)}}
        </span>
      </span>
      <span class="ticket-meta">
        {{textoTipo(ticket.tipo, ticket.tipoOutroDescricao)}} - {{textoArea(ticket.areaSistema)}}
      </span>
      <span class="ticket-idade" [ngClass]="classeIdade(ticket)">
        {{textoIdade(ticket)}}
      </span>
      <span class="ticket-meta" *ngIf="ticket.responsavelNome">
        {{ticket.responsavelNome}}
      </span>
    </button>
  </div>

  <section class="tickets-recentes"
           *ngIf="carregandoResolvidosRecentes || erroResolvidosRecentes || existemResolvidosRecentes">
    <div class="tickets-recentes-topo">
      <div>
        <p class="secao-label">Resolvidos recentes</p>
        <h5>Últimos 3 tickets</h5>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="erroResolvidosRecentes">
      {{erroResolvidosRecentes}}
    </div>

    <div class="estado-vazio" *ngIf="carregandoResolvidosRecentes">
      Carregando histórico recente...
    </div>

    <div class="tickets-lista tickets-lista-recentes" *ngIf="!carregandoResolvidosRecentes && existemResolvidosRecentes">
      <button type="button"
              class="ticket-item ticket-resolvido"
              *ngFor="let ticket of ticketsResolvidosRecentes"
              [class.selecionado]="ticketSelecionado?.id === ticket.id"
              (click)="selecioneTicket(ticket)">
        <span class="ticket-titulo">
          <small class="ticket-numero">#{{ticket.id}}</small>
          {{ticket.titulo}}
        </span>
        <span class="ticket-meta">
          Resolvido em {{(ticket.dataFechamento || ticket.dataAtualizacao) | date:'dd/MM HH:mm'}}
        </span>
        <span class="ticket-avaliacao-estrelas"
              [ngClass]="classeNotaAvaliacaoTicket(ticket)"
              *ngIf="temNotaAvaliacaoTicket(ticket)">
          {{estrelasAvaliacaoTicket(ticket)}}
          <small>{{ticket.avaliacaoSuporteNota}}/5</small>
        </span>
        <span class="ticket-meta">
          {{textoTipo(ticket.tipo, ticket.tipoOutroDescricao)}} - {{textoArea(ticket.areaSistema)}}
        </span>
        <span class="ticket-meta" *ngIf="ticket.responsavelNome">
          {{ticket.responsavelNome}}
        </span>
      </button>
    </div>
  </section>

  <section class="ticket-detalhe" *ngIf="ticketSelecionado">
    <div class="detalhe-topo">
      <div>
        <p class="secao-label">Ticket #{{ticketSelecionado.id}}</p>
        <h5>{{ticketSelecionado.titulo}}</h5>
        <span class="ticket-meta">
          Criado por {{ticketSelecionado.criadoPorNome}} em {{ticketSelecionado.dataCriacao | date:'dd/MM/yyyy HH:mm'}}
        </span>
        <span class="ticket-idade detalhe-idade" [ngClass]="classeIdade(ticketSelecionado)">
          {{textoIdade(ticketSelecionado)}}
        </span>
        <span class="badge badge-prioridade detalhe-prioridade" [ngClass]="classePrioridade(ticketSelecionado.prioridade)">
          {{textoPrioridade(ticketSelecionado.prioridade)}}
        </span>
      </div>

      <div class="detalhe-acoes">
        <button type="button"
                class="btn btn-primary btn-sm"
                *ngIf="podeAssumirTicket()"
                (click)="assumaTicket()"
                [disabled]="salvando">
          Assumir
        </button>

        <button type="button"
                class="btn btn-outline-primary btn-sm"
                (click)="abraGrupoTicket(ticketSelecionado)"
                *ngIf="podeAbrirGrupoTicket(ticketSelecionado)">
          <i class="fab fa-whatsapp mr-1"></i>
          Abrir grupo
        </button>

        <button type="button"
                class="btn btn-outline-warning btn-sm"
                (click)="abraEnviarDesenvolvimento()"
                *ngIf="podeEnviarDesenvolvimento()"
                [disabled]="salvando">
          <i class="fa fa-code mr-1"></i>
          Enviar ao desenvolvimento
        </button>
      </div>
    </div>

    <p class="descricao-ticket" *ngIf="ticketSelecionado.descricao">
      {{ticketSelecionado.descricao}}
    </p>

    <div class="desenvolvimento-ticket" *ngIf="ticketSelecionado.desenvolvimentoTicket">
      <div>
        <p class="secao-label">Desenvolvimento</p>
        <strong>#{{ticketSelecionado.desenvolvimentoTicket.id}} - {{ticketSelecionado.desenvolvimentoTicket.titulo}}</strong>
        <span class="ticket-meta d-block">
          {{textoStatus(ticketSelecionado.desenvolvimentoTicket.status)}} - {{ticketSelecionado.desenvolvimentoTicket.responsavelNome || 'sem responsavel'}}
        </span>
        <div class="desenvolvimento-info" *ngIf="ticketSelecionado.desenvolvimentoUltimaInteracaoTexto">
          <span class="badge badge-primary" *ngIf="ticketSelecionado.desenvolvimentoNovaInformacao">
            Nova informação
          </span>
          <span class="ticket-meta d-block">
            {{ticketSelecionado.desenvolvimentoUltimaInteracaoUsuarioNome}} em {{ticketSelecionado.desenvolvimentoUltimaInteracaoEm | date:'dd/MM/yyyy HH:mm'}}
          </span>
          <p>{{ticketSelecionado.desenvolvimentoUltimaInteracaoTexto}}</p>
        </div>
      </div>

      <a class="btn btn-outline-primary btn-sm"
         [href]="'/superadmin/desenvolvimento/tickets?ticketId=' + ticketSelecionado.desenvolvimentoTicket.id"
         target="_blank"
         rel="noopener">
        Abrir ticket dev
      </a>
    </div>

    <div class="avaliacao-ticket" *ngIf="ticketSelecionado.avaliacaoSuporte">
      <div>
        <p class="secao-label">Avaliação do atendimento</p>
        <strong>{{textoStatusAvaliacao(ticketSelecionado.avaliacaoSuporte.status)}}</strong>
        <span class="ticket-meta d-block" *ngIf="ticketSelecionado.avaliacaoSuporte.mensagemEnviadaEm">
          Enviada em {{ticketSelecionado.avaliacaoSuporte.mensagemEnviadaEm | date:'dd/MM HH:mm'}}
        </span>
        <span class="ticket-meta d-block" *ngIf="ticketSelecionado.avaliacaoSuporte.respondidaEm">
          Respondida em {{ticketSelecionado.avaliacaoSuporte.respondidaEm | date:'dd/MM HH:mm'}}
        </span>
      </div>

      <div class="avaliacao-resposta" *ngIf="ticketSelecionado.avaliacaoSuporte.status === 'RESPONDIDA'">
        <span class="badge badge-success">{{textoNotaAvaliacao(ticketSelecionado.avaliacaoSuporte)}}</span>
        <span class="badge badge-light">
          {{ticketSelecionado.avaliacaoSuporte.resolveuProblema ? 'Problema resolvido' : 'Ainda precisa atenção'}}
        </span>
        <p *ngIf="ticketSelecionado.avaliacaoSuporte.comentario">
          {{ticketSelecionado.avaliacaoSuporte.comentario}}
        </p>
      </div>

      <button type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="envieAvaliacaoSuporteManual()"
              [disabled]="salvando"
              *ngIf="podeEnviarAvaliacaoSuporte()">
        <i class="fab fa-whatsapp mr-1"></i>
        Enviar avaliação
      </button>
    </div>

    <div class="classificacao-ticket">
      <p class="secao-label">Reclassificar ticket</p>

      <div class="linha-form">
        <div class="form-group">
          <label>Tipo</label>
          <select class="form-control"
                  [(ngModel)]="ticketSelecionado.tipo"
                  name="tipoTicketSelecionado"
                  [disabled]="salvando">
            <option *ngFor="let tipo of tiposTicket" [ngValue]="tipo.valor">
              {{tipo.texto}}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Área do sistema</label>
          <select class="form-control"
                  [(ngModel)]="ticketSelecionado.areaSistema"
                  name="areaTicketSelecionado"
                  [disabled]="salvando">
            <option *ngFor="let area of areasSistema" [ngValue]="area.valor">
              {{area.texto}}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Prioridade</label>
          <select class="form-control"
                  [(ngModel)]="ticketSelecionado.prioridade"
                  name="prioridadeTicketSelecionado"
                  [disabled]="salvando">
            <option *ngFor="let prioridade of prioridades" [ngValue]="prioridade.valor">
              {{prioridade.texto}}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group" *ngIf="ticketSelecionado.tipo === 'OUTRO'">
        <label>Descrição do tipo</label>
        <input type="text"
               class="form-control"
               [(ngModel)]="ticketSelecionado.tipoOutroDescricao"
               name="tipoOutroTicketSelecionado"
               maxlength="120"
               autocomplete="off"
               [disabled]="salvando">
      </div>

      <button type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="salveClassificacao()"
              [disabled]="salvando">
        Salvar reclassificação
      </button>
    </div>

    <div class="linha-form">
      <div class="form-group status-acoes-ticket">
        <label>Status</label>
        <div class="status-botoes">
          <button type="button"
                  class="btn btn-outline-primary btn-sm"
                  [class.ativo]="statusAtual('ABERTO')"
                  (click)="mudeStatus('ABERTO')"
                  [disabled]="salvando || statusAtual('ABERTO')">
            Aberto
          </button>
          <button type="button"
                  class="btn btn-outline-primary btn-sm"
                  [class.ativo]="statusAtual('EM_ANDAMENTO')"
                  (click)="mudeStatus('EM_ANDAMENTO')"
                  [disabled]="salvando || statusAtual('EM_ANDAMENTO')">
            Em andamento
          </button>
          <button type="button"
                  class="btn btn-outline-primary btn-sm"
                  [class.ativo]="statusAtual('AGUARDANDO_CLIENTE')"
                  (click)="mudeStatus('AGUARDANDO_CLIENTE')"
                  [disabled]="salvando || statusAtual('AGUARDANDO_CLIENTE')">
            Aguardando cliente
          </button>
          <button type="button"
                  class="btn btn-success btn-sm"
                  [class.ativo]="statusAtual('RESOLVIDO')"
                  (click)="abraResolverTicket()"
                  [disabled]="salvando || statusAtual('RESOLVIDO') || !podeResolverTicket()">
            Marcar como resolvido
          </button>
          <button type="button"
                  class="btn btn-outline-danger btn-sm"
                  [class.ativo]="statusAtual('CANCELADO')"
                  (click)="abraCancelarTicket()"
                  [disabled]="salvando || statusAtual('CANCELADO')">
            Cancelar ticket
          </button>
        </div>
      </div>

      <div class="form-group">
        <label>Responsável</label>
        <select class="form-control"
                [ngModel]="ticketSelecionado.responsavelUsuarioId"
                (ngModelChange)="altereResponsavel($event)"
                name="responsavelTicketSelecionado"
                [disabled]="salvando || !podeTransferirTicket()">
          <option [ngValue]="null">Sem responsável</option>
          <option *ngFor="let responsavel of responsaveis" [ngValue]="responsavel.id">
            {{responsavel.nome}}
          </option>
        </select>
      </div>
    </div>

    <div class="registro-info">
      <div class="form-group">
        <label>Comentário</label>
        <textarea class="form-control"
                  rows="2"
                  name="comentarioTicket"
                  [(ngModel)]="comentarioTexto"></textarea>
        <button type="button"
                class="btn btn-outline-primary btn-sm mt-2"
                (click)="adicioneComentario()"
                [disabled]="salvando">
          Adicionar comentário
        </button>
      </div>

      <div class="form-group">
        <label>Informação de contexto</label>
        <textarea class="form-control"
                  rows="2"
                  name="contextoTicket"
                  [(ngModel)]="contextoTexto"></textarea>
        <button type="button"
                class="btn btn-outline-primary btn-sm mt-2"
                (click)="adicioneContexto()"
                [disabled]="salvando">
          Adicionar contexto
        </button>
      </div>
    </div>

    <div class="atendimentos-ticket" *ngIf="ticketSelecionado.atendimentos?.length">
      <p class="secao-label">Atendentes</p>

      <div class="atendimento" *ngFor="let atendimento of ticketSelecionado.atendimentos">
        <div>
          <strong>{{atendimento.usuarioNome}}</strong>
          <span class="badge badge-success ml-1" *ngIf="atendimento.emAndamento">Atual</span>
          <span class="ticket-meta d-block">
            <i class="fa atendimento-tipo-icone mr-1"
               [ngClass]="iconeTipoAtendimento(atendimento.tipo)"
               *ngIf="iconeTipoAtendimento(atendimento.tipo)"></i>
            {{textoTipoAtendimento(atendimento.tipo)}} por {{atendimento.iniciadoPorNome}}
          </span>
        </div>
        <div class="atendimento-tempo">
          <span>
            {{atendimento.dataInicio | date:'dd/MM HH:mm'}}
            <ng-container *ngIf="atendimento.dataFim">até {{atendimento.dataFim | date:'dd/MM HH:mm'}}</ng-container>
            <ng-container *ngIf="!atendimento.dataFim">até agora</ng-container>
          </span>
          <strong>{{textoDuracaoAtendimento(atendimento)}}</strong>
        </div>
      </div>
    </div>

    <div class="anexo-ticket">
      <label>Print</label>
      <div class="input-group">
        <input type="file"
               class="form-control"
               accept="image/*"
               (change)="selecioneArquivo($event)">
        <div class="input-group-append">
          <button type="button"
                  class="btn btn-outline-primary"
                  (click)="envieAnexo()"
                  [disabled]="salvando || !arquivoSelecionado">
            Anexar
          </button>
        </div>
      </div>
    </div>

    <div class="anexos" *ngIf="ticketSelecionado.anexos?.length">
      <a *ngFor="let anexo of ticketSelecionado.anexos"
         [href]="anexo.url"
         target="_blank"
         rel="noopener"
         class="anexo-link">
        <i class="fa fa-image mr-1"></i>
        {{anexo.nomeOriginal || anexo.arquivo}}
      </a>
    </div>

    <div class="interacoes" *ngIf="ticketSelecionado.interacoes?.length">
      <div class="interacao" *ngFor="let interacao of ticketSelecionado.interacoes">
        <div class="interacao-topo">
          <strong>{{interacao.usuarioNome}}</strong>
          <span>{{interacao.dataCriacao | date:'dd/MM/yyyy HH:mm'}}</span>
        </div>
        <p *ngIf="interacao.tipo === 'STATUS'">
          Status alterado de {{textoStatus(interacao.statusAnterior)}} para {{textoStatus(interacao.statusNovo)}}.
        </p>
        <p *ngIf="interacao.tipo === 'RESPONSAVEL'">
          Responsável alterado para {{interacao.responsavelNovoNome || 'sem responsável'}}.
        </p>
        <p *ngIf="interacao.tipo === 'RESOLUCAO'">
          <span class="badge badge-success">Resolução</span>
          {{interacao.texto}}
        </p>
        <p *ngIf="interacao.tipo === 'CANCELAMENTO'">
          <span class="badge badge-danger">Cancelamento</span>
          {{interacao.texto}}
        </p>
        <p *ngIf="interacao.tipo !== 'STATUS' && interacao.tipo !== 'RESPONSAVEL' && interacao.tipo !== 'RESOLUCAO' && interacao.tipo !== 'CANCELAMENTO'">
          <span class="badge badge-light">{{interacao.tipo}}</span>
          {{interacao.texto}}
        </p>
      </div>
    </div>
  </section>

  <div class="modal-resolucao-backdrop" *ngIf="resolucaoModalAberto">
    <form class="modal-resolucao" (ngSubmit)="confirmeResolucao()">
      <h5>Marcar ticket como resolvido</h5>
      <p>Descreva como este ticket foi resolvido.</p>

      <textarea class="form-control"
                rows="4"
                name="resolucaoTicketSuporte"
                [(ngModel)]="resolucaoTexto"
                [disabled]="salvando"></textarea>

      <div class="alert alert-danger mt-2" *ngIf="erroResolucao">
        {{erroResolucao}}
      </div>

      <div class="modal-resolucao-acoes">
        <button type="button"
                class="btn btn-link btn-sm"
                (click)="canceleResolucao()"
                [disabled]="salvando">
          Cancelar
        </button>
        <button type="submit"
                class="btn btn-success btn-sm"
                [disabled]="salvando">
          <i class="fa" [ngClass]="salvando ? 'fa-spinner fa-spin' : 'fa-check'"></i>
          Marcar como resolvido
        </button>
      </div>
    </form>
  </div>

  <div class="modal-resolucao-backdrop" *ngIf="desenvolvimentoModalAberto">
    <form class="modal-resolucao" (ngSubmit)="confirmeEnviarDesenvolvimento()">
      <h5>Enviar ao desenvolvimento</h5>
      <p>Crie um ticket tecnico vinculado a este atendimento.</p>

      <div class="form-group">
        <label>Titulo</label>
        <input class="form-control"
               name="tituloDesenvolvimentoSuporte"
               [(ngModel)]="desenvolvimentoTicket.titulo"
               [disabled]="enviandoDesenvolvimento">
      </div>

      <div class="form-group">
        <label>Descricao tecnica</label>
        <textarea class="form-control"
                  rows="4"
                  name="descricaoDesenvolvimentoSuporte"
                  [(ngModel)]="desenvolvimentoTicket.descricao"
                  [disabled]="enviandoDesenvolvimento"></textarea>
      </div>

      <div class="linha-form">
        <div class="form-group">
          <label>Solicitante/Cliente</label>
          <input class="form-control"
                 name="solicitanteDesenvolvimentoSuporte"
                 [(ngModel)]="desenvolvimentoTicket.solicitanteCliente"
                 [disabled]="enviandoDesenvolvimento">
        </div>

        <div class="form-group">
          <label>Arquivo/link</label>
          <input class="form-control"
                 name="arquivoDesenvolvimentoSuporte"
                 [(ngModel)]="desenvolvimentoTicket.arquivoUrl"
                 [disabled]="enviandoDesenvolvimento">
        </div>
      </div>

      <div class="linha-form">
        <div class="form-group">
          <label>Prioridade</label>
          <select class="form-control"
                  name="prioridadeDesenvolvimentoSuporte"
                  [(ngModel)]="desenvolvimentoTicket.prioridade"
                  [disabled]="enviandoDesenvolvimento">
            <option *ngFor="let prioridade of prioridadesDesenvolvimento" [ngValue]="prioridade.valor">
              {{prioridade.texto}}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Area</label>
          <select class="form-control"
                  name="areaDesenvolvimentoSuporte"
                  [(ngModel)]="desenvolvimentoTicket.areaSistema"
                  [disabled]="enviandoDesenvolvimento">
            <option *ngFor="let area of areasSistema" [ngValue]="area.valor">
              {{area.texto}}
            </option>
          </select>
        </div>
      </div>

      <div class="linha-form">
        <div class="form-group">
          <label>Previsao conclusao</label>
          <input type="date"
                 class="form-control"
                 name="previsaoDesenvolvimentoSuporte"
                 [(ngModel)]="desenvolvimentoTicket.previsaoConclusao"
                 [disabled]="enviandoDesenvolvimento">
        </div>
      </div>

      <div class="alert alert-danger mt-2" *ngIf="erroDesenvolvimento">
        {{erroDesenvolvimento}}
      </div>

      <div class="modal-resolucao-acoes">
        <button type="button"
                class="btn btn-link btn-sm"
                (click)="canceleDesenvolvimento()"
                [disabled]="enviandoDesenvolvimento">
          Cancelar
        </button>
        <button type="submit"
                class="btn btn-warning btn-sm"
                [disabled]="enviandoDesenvolvimento">
          <i class="fa" [ngClass]="enviandoDesenvolvimento ? 'fa-spinner fa-spin' : 'fa-code'"></i>
          Enviar
        </button>
      </div>
    </form>
  </div>

  <div class="modal-resolucao-backdrop" *ngIf="cancelamentoModalAberto">
    <form class="modal-resolucao" (ngSubmit)="confirmeCancelamento()">
      <h5>Cancelar ticket</h5>
      <p>Informe por que este ticket está sendo cancelado.</p>

      <textarea class="form-control"
                rows="4"
                name="cancelamentoTicketSuporte"
                [(ngModel)]="cancelamentoTexto"
                [disabled]="salvando"></textarea>

      <div class="alert alert-danger mt-2" *ngIf="erroCancelamento">
        {{erroCancelamento}}
      </div>

      <div class="modal-resolucao-acoes">
        <button type="button"
                class="btn btn-link btn-sm"
                (click)="canceleCancelamento()"
                [disabled]="salvando">
          Manter aberto
        </button>
        <button type="submit"
                class="btn btn-danger btn-sm"
                [disabled]="salvando">
          <i class="fa" [ngClass]="salvando ? 'fa-spinner fa-spin' : 'fa-ban'"></i>
          Cancelar ticket
        </button>
      </div>
    </form>
  </div>
</div>
